export class LoadPageSpeedSettingsError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "LoadPageSpeedSettingsError";
  }
}
